import { Toast } from 'vant'
import { OpsNoteCreateRequest } from './OpsNoteCreateRequest'
import { createOperationNotes, getCopyLengthLimit } from './OpsNoteApis'
import { t } from '@/i18n'
import Analytics from '@/core/Analytics'
import { Env } from '@loca/mfe-vue3'


class CopyManager {
  public copyLengthLimit = 100 // 复制的长度限制，默认100字

  constructor() {
    this.getCopyListener()
  }

  // copy事件监听函数
  public copyListener!: (e: ClipboardEvent) => any

  // 产生监听器函数
  public getCopyListener() {
    if (typeof this.copyListener !== 'function') {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this
      this.copyListener = function (e: ClipboardEvent) {
        // 图片不会被包含在getSelection()里，也就是图片不会触发copy事件，且copy事件里也不会包含图片
        const text = window.getSelection() + ''
        if (!text || !e) {
          // 没有长度，直接返回
          return
        }
        const target = e.target as any
        // 以前海外针对input和textarea输入框，也是可以复制的，因为输入框user-select:none的话ios会不能正常使用。
        // 所以非输入框才限制长度
        if (!(target && (target.nodeName === 'TEXTAREA' || target.nodeName === 'INPUT'))) {
          // 长度大于N或者不是文字，则禁止复制并提示
          if (text.length > that.copyLengthLimit) {
            // 如果文本存在，首先取消默认行为。
            // synthetic (en-US) copy 事件没有默认行为，除非：
            // 如果默认事件没有取消，就复制到选区（如果有选中内容）到剪切板；
            // 如果取消了默认事件，但是调用了setData()方法：就复制clipboardData的内容到到剪切板；
            // 如果取消了默认行为，而且没有调用setData()方法，就没有任何行为。即取消copy行为，保留以前的copy值
            e.preventDefault()
            Toast(t('globalCopyErrMsg', { max: that.copyLengthLimit }))
            return
          }
        }
        // 正常，异步记录操作日志
        // that.writeOperationNotes()
        that.trackCopyClick()
      }
    }
    return this.copyListener
  }

  public trackCopyClick() {
    Analytics.track('CopyClick')
  }

  // 开启全应用复制监听
  public start() {
    if (['local'].indexOf(Env.getEnv()) !== -1) {
      // 本地环境不记录日志了
      return
    }
    // 获取配置
    this.getCopyConfig()
    // 添加监听函数。放在capture阶段是为了必定执行。
    document.addEventListener('copy', this.getCopyListener(), true)
  }

  // 关闭全应用复制监听
  public end() {
    // 移除监听函数
    document.removeEventListener('copy', this.getCopyListener(), true)
  }

  // 写操作日志
  public writeOperationNotes() {
    const request = new OpsNoteCreateRequest()
    request.url = location.href
    createOperationNotes(request)
  }

  // 获取配置里的复制长度限制
  public async getCopyConfig() {
    const res = await getCopyLengthLimit('global_copy_length_limit')
    if (res && res.isValid() && res.data && res.data[0] && res.data[0].children &&
      res.data[0].children[0] && res.data[0].children[0].props) {
      const limit = parseInt(res.data[0].children[0].props.value, 10)
      if (!Number.isNaN(limit)) {
        this.copyLengthLimit = limit
      }
    }
  }
}

const copyManager = new CopyManager()
export default copyManager
